/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { BizPartnerDetailTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const bizPartnerDetailResetModelTimestamp = state => ({
  ...state,
  modelTimestamp: Date.now()
});

export const bizPartnerDetailSetResId = (state, { resId }) => ({
  ...state,
  modelTimestamp: Date.now(),
  resId
});

export const bizPartnerDetailShowModelLoading = (state, { boolean }) => ({
  ...state,
  modelIsLoading: boolean
});

export const bizPartnerDetailShowModelSuccess = (state, { model }) => ({
  ...state,
  model
});

export const bizPartnerDetailUpdateModelSuccess = (state, { model }) => ({
  ...state,
  model
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [BizPartnerDetailTypes.BIZ_PARTNER_DETAIL_RESET_MODEL_TIMESTAMP]: bizPartnerDetailResetModelTimestamp,
  [BizPartnerDetailTypes.BIZ_PARTNER_DETAIL_SET_RES_ID]: bizPartnerDetailSetResId,
  [BizPartnerDetailTypes.BIZ_PARTNER_DETAIL_SHOW_MODEL_LOADING]: bizPartnerDetailShowModelLoading,
  [BizPartnerDetailTypes.BIZ_PARTNER_DETAIL_SHOW_MODEL_SUCCESS]: bizPartnerDetailShowModelSuccess,
  [BizPartnerDetailTypes.BIZ_PARTNER_DETAIL_UPDATE_MODEL_SUCCESS]: bizPartnerDetailUpdateModelSuccess
});
